import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, compose, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import {
  ConnectedRouter,
  connectRouter,
  routerMiddleware
} from 'connected-react-router';
// import { Route, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import thunk from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';
import { createLogger } from 'redux-logger';

import rootReducer from './rootReducer';
// import { AppContainer  as ReactContainer } from 'react-hot-loader';
import AppContainer from './app/AppContainer';

let basename = '';

if (
  process.env.NODE_ENV === 'staging' ||
  process.env.NODE_ENV === 'production'
) {
  basename = '/tour';
}

const history = createBrowserHistory({
  basename: basename
});

const routersMid = routerMiddleware(history);
const logger = createLogger();

const configureStore = () => {
  const store = createStore(
    connectRouter(history)(rootReducer),
    compose(applyMiddleware(routersMid, thunk, promiseMiddleware()))
  );
  if (module.hot) {
    module.hot.accept('./rootReducer', () => {
      const nextRootReducer = require('./rootReducer');
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
};

const store = configureStore();

const render = () => {
  const contentRoot = document.getElementById('app');
  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <AppContainer />
      </ConnectedRouter>
    </Provider>,
    contentRoot
  );
};

render();

if (module.hot) {
  module.hot.accept('./app/AppContainer', () => {
    const NextRoutes = require('./app/AppContainer').default;
    render(NextRoutes);
  });
}
